import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkDutyReturnType implements BaseEnumType {
  private static allValues: EnumUkDutyReturnType[] = []; // make sure this is top-most
  
  public static none = new EnumUkDutyReturnType(0, "None", "enum_uk_duty_return_type_none");
  public static beforeAug1DutyReturn = new EnumUkDutyReturnType(1, "BeforeAug1DutyReturn", "enum_uk_duty_return_type_before_aug1_duty_return");
  public static afterAug1DutyReturn = new EnumUkDutyReturnType(2, "AfterAug1DutyReturn", "enum_uk_duty_return_type_after_aug1_duty_return");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkDutyReturnType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkDutyReturnType.none; }
  public isBeforeAug1DutyReturn() { return this === EnumUkDutyReturnType.beforeAug1DutyReturn; }
  public isAfterAug1DutyReturn() { return this === EnumUkDutyReturnType.afterAug1DutyReturn; }

  public static getValues(): readonly EnumUkDutyReturnType[] {
    return EnumUkDutyReturnType.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkDutyReturnType[] {
    return EnumUkDutyReturnType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkDutyReturnType {
    const found = EnumUkDutyReturnType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkDutyReturnType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkDutyReturnType): EnumUkDutyReturnType {
    const found = name ? EnumUkDutyReturnType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkDutyReturnType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkDutyReturnType>): boolean {
    return this.key === other?.key;
  }
}